import React from 'react';
import { Surface as PaperSurface } from 'react-native-paper';

import { useAppTheme } from '@context/ThemeContext';

export type SurfaceProps = React.ComponentProps<typeof PaperSurface>;

export default function Surface({ style, ...props }: SurfaceProps) {
  const appTheme = useAppTheme();

  return <PaperSurface style={[{ borderRadius: appTheme.roundness }, style]} {...props} />;
}
